import { clone } from "lodash";
import { sitesPipelineStore } from "../store";

type UpdateRowHeightsArgs = {
  stageId: string;
  toIndex: number;
  fromIndex: number;
};

export function updateRowHeightsWithinStage({ stageId, toIndex, fromIndex }: UpdateRowHeightsArgs) {
  const rowHeights = clone(sitesPipelineStore.getRowHeightsByStageId?.[stageId]?.());

  if (!rowHeights) return;

  const [movingRowHeight] = rowHeights.splice(fromIndex, 1);
  rowHeights.splice(toIndex, 0, movingRowHeight);

  sitesPipelineStore.setRowHeightsByStageId[stageId](rowHeights);
}
